module.exports = __webpack_public_path__ + "static/img/logo2.bf12432d.png";